"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const conference_room_1 = require("./conference_room");
const logger_1 = require("./util/logger");
const webrtc_utils_1 = require("./util/webrtc_utils");
class ARaaSSession {
    constructor(logger, messageHandler) {
        this.messageHandler = messageHandler;
        (0, logger_1.configureARaaSClientSDKLogger)(logger);
    }
    static getCodecCapabilities(mediaType) {
        return webrtc_utils_1.WebRTCUtils.queryCodecCapabilities(mediaType);
    }
    joinRoom(config) {
        logger_1.logger.info("[ARaaS] Creating new conference room with config: ", config);
        this.conference = new conference_room_1.ConferenceRoom(config, this.messageHandler);
        this.conference.register();
    }
    leaveRoom() {
        var _a;
        (_a = this.conference) === null || _a === void 0 ? void 0 : _a.leaveRoom();
    }
    dataChannelSend(message) {
        this.conference.dataChannelSend(message);
    }
    passDownElements(elementsToPass) {
        this.conference.passDownElements(elementsToPass);
    }
    replaceMediaStreamForParticipant(participantId, newMediaStreamTrack) {
        logger_1.logger.info(`ARaaS] Replacing MediaStreamTrack for participant ${participantId}`);
        this.conference.updateTrackForParticipant(participantId, newMediaStreamTrack);
    }
    getStats() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.conference.getStats();
        });
    }
}
exports.default = ARaaSSession;
//# sourceMappingURL=araas_session.js.map